import component from './StockConstructor.vue'
export default component
